import NotificationsMarkAllAsReadButton from './container';
export default NotificationsMarkAllAsReadButton;
